import { useState, useEffect, useMemo } from "react";
import { Box, Container, Grid, Tooltip } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import Fab from "../../../../components/Fab";
import FilterSelect from "../../../../components/FilterSelect";
import Template from "../../../../components/Template";
import ContractReportsList from "./ContractReportsList";
import { fixedContracts, filterFixedContracts, getFixedContractsByFields } from "../../../../apis";
import { DownloadExcel } from "../../../../components/DownloadExcel";
import useToken from "../../../../hooks/useToken";
import _ from "lodash";
import Snackbar from "../../../../components/Snackbar";
import { useNavigate } from "react-router-dom";
import { routeBuilder } from '../../../../utils/routeBuilder'
import { getDefaultCompany, dateFormat } from "../../../common";
import { commonStrings } from "../../../../components/StringBundle";
import { useGlobalStyles } from "../../../../components/globalStyles";
import { getContractReportCompanyFilterList, isContractReportCompanyFilterDisabled, getContractReportDateRangePayload } from "../constant";

export const formatToSelection = (data = [], key, id) => {
  let formattedData = [];
  data.length > 0 && data.map((v) => formattedData.push({ label: v[key], value: v[id] }));
  return formattedData;
};

const formatDate = (datestr) => {
  let dateVal = new Date(datestr);
    return (
      dateVal.getFullYear() + 
      "-" +
      (dateVal.getMonth() + 1) +
      "-" +
      dateVal.getDate()
    );
};

const ContractReports = (props) => {
  const { getCurrentUserDetails } = useToken();
  const currentUserDetails = getCurrentUserDetails();
  const role = currentUserDetails.role;
  const currentUserId = currentUserDetails.id;
  const globalClasses = useGlobalStyles();
  const [filter, setFilter] = useState(null);
  const [fixedReport, setFixedReport] = useState(null);
  const [showDownloadExcel, setShowDownloadExcel] = useState(false);
  const [GCList, setGCList] = useState([]); 
  const [ContractList, setContractList] = useState([]); 
  const [supplierList, setSupplierList] = useState([]); 
  const [allFiters, setAllFiters] = useState({});
  const [FixedReportexcel,setFixedReportexcel]= useState(null);
  const [showSnack, setSnack] = useState({ open: false, message: '', severity: '' });
  const [company, setCompany] = useState(() => getDefaultCompany(role, "contractReportCompany"));
  const navigate = useNavigate();

  const companyFilterList = useMemo(() => getContractReportCompanyFilterList(role), [role]);
  const companyFilterDisabled = useMemo(() => isContractReportCompanyFilterDisabled(role), [role]);

  const dateRangePayload = useMemo(
    () => getContractReportDateRangePayload(allFiters, changeFilter),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allFiters?.dispatch_from, allFiters?.dispatch_to]
  );

  function handleCompanyChange(e) {
    const v = e.target.value;
    setCompany(v);
    sessionStorage.setItem("contractReportCompany", v);
  }

  const getData = async () => {
    let filterString = "";

    let data = { filter: filterString, loggedinuserid: currentUserId };

    try {
      let response = await fixedContracts(data);
      if (response) {
        setFixedReport(response);
        let temp = [];
        response.map(item => {
            temp.push({
              ...item,                
              podate: dateFormat(item.podate, 'DD-MMM-YYYY'),
              contractdate:dateFormat(item.contractdate, 'DD-MMM-YYYY'),
              dispatch_date:dateFormat(item.dispatch_date, 'DD-MMM-YYYY'),
              fixation_date:dateFormat(item.dispatch_date, 'DD-MMM-YYYY'),
              booked_terminal_month:dateFormat(item.booked_terminal_month, 'MMM-YYYY'),
              fixed_terminal_month:dateFormat(item.fixed_terminal_month, 'MMM-YYYY'),
              terminal_month:dateFormat(item.terminal_month, 'MMM-YYYY'),
            });
        });
        setFixedReportexcel(temp);

      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError,
        severity: 'error',
      })
    }

  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const resolvedCompany = company === commonStrings.all ? "CCL" : company;

    filterFixedContracts({"type":"GCItemName", "company_name": resolvedCompany}).then((res) => {
      setGCList(res === null ? [] : formatToSelection(res, "gc_itemname", "gc_itemname"));
    });

    filterFixedContracts({"type":"ContractNo", "company_name": resolvedCompany}).then((res) => {
      setContractList(res === null ? [] : formatToSelection(res, "contractno", "contractno"));
    });

    filterFixedContracts({"type":"VendorName", "company_name": resolvedCompany}).then((res) => {
      setSupplierList(res === null ? [] : formatToSelection(res, "vendorname", "vendorname"));
    });

  }, [company]);

  const exportExcel = () => {
    setShowDownloadExcel(true);
  };

  function changeFilter(val, type) {
    let temp = {...allFiters};
    temp[type] = val;
    setAllFiters(temp);
  }

  function changeFilterGc(e) {
    let temp = {...allFiters};
    temp.gc = e.target.value;
    setAllFiters(temp);
  }

  function changeFilterContract(e) {
    let temp = {...allFiters};
    temp.contract = e.target.value;
    setAllFiters(temp);
  }

  function changeFilterSupplier(e) {
    let temp = {...allFiters};
    temp.supplier = e.target.value;
    setAllFiters(temp);
  }

  async function filterReport() {
    const resolvedCompany = company === commonStrings.all ? "CCL" : company;
    let data = {
      "contract_no":allFiters.contract || '',
      "vendorname":allFiters.supplier || '',
      "gc_itemname":allFiters.gc || '',
      "dispatch_date_to":allFiters.dispatch_to ? formatDate(allFiters.dispatch_to) : null,
      "dispatch_date_from":allFiters.dispatch_from ? formatDate(allFiters.dispatch_from) : null,
      "company_name": resolvedCompany
    };

    try {
      let response = await getFixedContractsByFields(data)
        setFixedReport(response === null ? [] : response);
  } catch (e) {
      setSnack({
          open: true,
          message: commonStrings.serverError,
          severity: 'error',
      })
  }
  }

  return <Container className={globalClasses.mrinroot}> <>
    {showSnack.open && <Snackbar {...showSnack} handleClose={() => setSnack({ open: false, message: '', severity: '' })} />}
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={6} md={3}>
          <FilterSelect
            id="contract-report-company"
            label={commonStrings.company}
            value={company}
            onChange={handleCompanyChange}
            options={companyFilterList}
            disabled={companyFilterDisabled}
          />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Template payload={dateRangePayload} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}></Grid>
      <Grid item xs={12} sm={4} md={3}>
          <FilterSelect
            id="contract-report-supplier"
            label="Supplier"
            value={allFiters?.supplier || ''}
            onChange={changeFilterSupplier}
            options={supplierList}
          />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
          <FilterSelect
            id="contract-report-gc"
            label="Green Coffee Type"
            value={allFiters?.gc || ''}
            onChange={changeFilterGc}
            options={GCList}
          />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
          <FilterSelect
            id="contract-report-contract"
            label="Contract no."
            value={allFiters?.contract || ''}
            onChange={changeFilterContract}
            options={ContractList}
          />
      </Grid>
      <Grid item xs />
      <Grid item xs="auto">
                <Box display="flex" alignItems="center" className={globalClasses.gap10}>
                   <Tooltip title={!fixedReport?.length ? commonStrings.noDataToExport : commonStrings.ExportToExcel} placement="top" arrow>
            <span>
              <Fab
                onClick={() => exportExcel()}
                label=""
                disabled={!fixedReport?.length}
                iconAddExcel="excel"
              />
            </span>
          </Tooltip>
          <Tooltip title={commonStrings.filter} placement="top" arrow>
            <span>
              <Fab onClick={() => filterReport()} label="" icon={<FilterListIcon />} />
            </span>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
    {showDownloadExcel === true && (
      <DownloadExcel tableData={FixedReportexcel} tableName="Fixed Report" />
    )}
    <ContractReportsList
      selectedAdvancedFilters={(val) => setFilter(val)}
      clearAdvancedFilters={() => setFilter(null)}
      data={fixedReport}
      gcDetails={(event, gcId) => navigate(routeBuilder('gc',gcId, 'view'))}
    />
  </>
  </Container>;
};

export default ContractReports;